import React, { useMemo, useState } from "react";
import { Marketers, News } from "../../pages";
import { MarketersController } from "../../controllers";

const MarketersContainer = () => {
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const marketersTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } = MarketersController.useGetMarketers(
    marketersTableQuery,
    filterQuery,
    searchQuery
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const filterHandler = async (query) => {
    setFilterQuery(query);
  };

  return (
    <Marketers
      onLimitChange={onLimitChange}
      data={data}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      limit={limit}
      isLoading={isLoading}
      isFetching={isFetching}
      setSearchQuery={setSearchQuery}
      filterHandler={filterHandler}
    />
  );
};

export default MarketersContainer;
